export default __webpack_public_path__ + "static/media/GlyGen-Logos.da308d9d.pdf";